import styled from 'styled-components';

const LineItemsListWrapper = styled.div<{
  isPaddingTop: boolean;
}>`
  padding: ${({ isPaddingTop }) =>
    isPaddingTop ? '16px' : '0px 16px 16px 16px'};
  background-color: ${({ theme }) => `${theme.configs.tertiaryBox.bgColor}`};
`;

export { LineItemsListWrapper };
